import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const AssessmentCreditPackService = {
    createCreditPackage,
    getAllPackages,
    updateCreditPackage,
    deleteCreditPackage,
    getAllActiveCreditPackages,
    getLimitOfBuyCreditPackages,
};

async function createCreditPackage(typeData) { 
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: typeData,  
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-packages/add`,  
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllPackages(node_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-packages/getAllCreditPackages/${node_id}`,  
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateCreditPackage(typeData, credit_package_id) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: typeData,
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-packages/updateCreditPackage/${credit_package_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteCreditPackage(credit_package_id, form_list_id) {
    const configOptions = {
        method: "DELETE",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-packages/deleteCreditPackage/${credit_package_id}/${form_list_id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllActiveCreditPackages(node_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-packages/getAllActiveCreditPackages/${node_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getLimitOfBuyCreditPackages() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/credit-buy-limit-setting/get`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}